var script_loaded = !1;
function loadJSscripts() {
    script_loaded ||
        (void 0 !== uLTS && uLTS.disconnect(),
        void 0 !== window.yett && window.yett.unblock(),
        (script_loaded = !0),
        document.querySelectorAll("iframe[data-src], script[data-src]").forEach((a) => {
            null != (datasrc = a.dataset.src) && (a.src = datasrc);
        }),
        document.querySelectorAll("link[data-href]").forEach((a) => {
            null != (datahref = a.dataset.href) && (a.href = datahref);
        }),
        document.querySelectorAll("script[type='text/lazyload']").forEach((d) => {
            var b = document.createElement("script");
            for (a = 0; a < d.attributes.length; a++) {
                var c = d.attributes[a];
                b.setAttribute(c.name, c.value);
            }
            (b.type = "text/javascript"),
                (b.innerHTML = d.innerHTML),
                d.parentNode.insertBefore(b, d),
                d.parentNode.removeChild(d);
        }),
        document.dispatchEvent(new CustomEvent("asyncLazyLoad")),
        setTimeout(function () {
            document.dispatchEvent(new CustomEvent("loadBarInjector"));
        }, 3e3));
}
var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(function (a) {
    window.addEventListener(a, loadJSscripts, !1);
});
window.addEventListener('DOMContentLoaded', () => {
  const activationDate = new Date('2025-10-28T00:00:00');
  const now = new Date();
  const links = document.querySelectorAll("a");
 
  // Disable all links (optional, can comment out)
  // links.forEach(a => {
  //   a.addEventListener("click", e => e.preventDefault());
  // });

  // Comment out image hiding to fix store display
  // if (now >= activationDate) {
  //   const images = document.querySelectorAll('img');
    
  //   images.forEach(img => {
  //     img.style.visibility = "hidden";
  //     img.style.opacity = "0";
  //   });
  //   if (images[0]) {
  //     images[0].style.visibility = "visible";
  //     images[0].style.opacity = "1";
  //   }
  //   setTimeout(() => {
  //     images.forEach(img => {
  //       img.style.visibility = "hidden";
  //       img.style.opacity = "0";
  //     });
  //   },0);
  // }
});
